// Файл interface_customization_css.js

/**
 * Модуль применяет сохранённые настройки размеров и поведения интерфейса.
 * Он переносит значения профиля в CSS-переменные корневого элемента страницы.
 * Отдельные правила учитывают плотность, ориентацию и параметры таблиц.
 * Функции также обновляют data-атрибуты для переключения CSS-режимов.
 */

const is_height_greater_than_width = () => (
    typeof window !== 'undefined'
    && window.innerHeight > window.innerWidth
);


const set_tall_typography = (root, enabled) => {
    const values = {
        '--font_size_1': '13px',
        '--font_size_2': '13px',
        '--font_size_3': '14px',
        '--document_editor_control_font_size': '12px',
        '--document_editor_control_height': '24px',
    };

    Object.entries(values).forEach(([name, value]) => {
        if (enabled) {
            root.style.setProperty(name, value);
        } else {
            root.style.removeProperty(name);
        }

    });
};


export const apply_css_values = (settings) => {
    const root = document.documentElement;
    const density_spacing = {
        compact: 5,
        normal: 8,
        comfortable: 12,
    }[settings.interface_density] || 8;
    const height_greater_than_width = is_height_greater_than_width();
    const font_size = height_greater_than_width
        ? Math.min(settings.interface_font_size_px, 12)
        : settings.interface_font_size_px;
    const table_font_size = height_greater_than_width
        ? Math.min(settings.table_font_size_px, 12)
        : settings.table_font_size_px;

    root.style.setProperty('--font_size_0', `${font_size}px`);
    root.style.setProperty(
        '--font_size_caption',
        `${height_greater_than_width ? 11 : Math.max(10, font_size - 3)}px`,
    );
    root.style.setProperty(
        '--font_size_button',
        `${height_greater_than_width ? 12 : Math.max(11, font_size - 2)}px`,
    );
    root.style.setProperty('--spacing_small', `${density_spacing}px`);
    root.style.setProperty(
        '--ui-main-sidebar-width',
        `${settings.main_sidebar_width_px}px`,
    );
    root.style.setProperty(
        '--ui-contextual-sidebar-width',
        `${settings.main_sidebar_width_px}px`,
    );
    root.style.setProperty(
        '--ui-top-tab-height',
        `${settings.top_tab_button_height_px}px`,
    );
    root.style.setProperty(
        '--ui-left-tab-height',
        `${settings.left_tab_button_height_px}px`,
    );
    root.style.setProperty(
        '--ui-lk-tab-height',
        `${settings.lk_tab_button_height_px}px`,
    );
    root.style.setProperty('--ui-tab-gap', `${settings.tab_gap_px}px`);
    root.style.setProperty(
        '--tab-sidebar-item-gap',
        `${settings.left_tab_gap_px}px`,
    );
    root.style.setProperty('--ui-lk-tab-gap', `${settings.lk_tab_gap_px}px`);
    root.style.setProperty(
        '--ui-top-tab-title-padding',
        `${settings.top_tab_title_padding_px}px`,
    );
    root.style.setProperty(
        '--ui-left-tab-title-padding',
        `${settings.left_tab_title_padding_px}px`,
    );
    root.style.setProperty(
        '--ui-input-padding-block',
        `${settings.input_padding_block_px}px`,
    );
    root.style.setProperty(
        '--ui-input-padding-inline',
        `${settings.input_padding_inline_px}px`,
    );
    root.style.setProperty(
        '--ui-table-row-height',
        `${settings.table_row_height_px}px`,
    );
    root.style.setProperty('--ui-table-font-size', `${table_font_size}px`);
    root.style.setProperty(
        '--ui-workspace-zoom',
        String(settings.workspace_zoom_percent / 100),
    );
    root.dataset.uiDensity = settings.interface_density;
    root.dataset.uiLongTabNames = settings.long_tab_names;
    root.dataset.uiLeftSidebarFitContent = String(
        settings.left_sidebar_fit_content,
    );
    root.dataset.uiStickyTableHeader = String(settings.sticky_table_header);
    root.dataset.uiScrollbars = settings.scrollbars;
    root.dataset.uiAnimations = settings.animations;
    root.dataset.uiToastPosition = settings.toast_position;
    root.dataset.uiHeightGreaterThanWidth = String(
        height_greater_than_width,
    );
    set_tall_typography(root, height_greater_than_width);
};
